import Reveal from '@/components/feature/Reveal';
import { collections } from '@/mocks/home';

export default function CollectionSection() {
  return (
    <section id="collections" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="font-label text-xs tracking-[0.28em] text-primary-600">
                COLLECTIONS
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                黑料导航资源合集
              </h2>
            </div>
            <p className="max-w-md text-sm leading-7 text-foreground-600">
              按主题打包的入口，省去逐个站点挑选的功夫，适合第一次来或想换个方向逛的时候。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:mt-10 md:grid-cols-3">
          {collections.map((col, index) => (
            <Reveal key={col.id} delay={index * 80}>
              <a
                href="#feed"
                className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-40 w-full overflow-hidden md:h-44">
                  <img
                    src={col.image}
                    alt={`${col.title}封面`}
                    title={`${col.title} 黑料导航资源合集`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {col.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-7 text-foreground-600">{col.desc}</p>
                  <div className="mt-4 flex flex-wrap items-center gap-1.5">
                    {col.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-accent-100 px-2 py-0.5 font-label text-[11px] text-accent-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="font-label text-xs text-foreground-500">{col.meta}</span>
                    <span className="flex items-center gap-1 font-label text-xs text-primary-700">
                      进入合集
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}